/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import './style/codeInput.scss';

import React, {ChangeEventHandler, KeyboardEventHandler, ReactElement} from 'react';

import classNames from 'classnames';

interface Props {
    onChange: (index: number) => ChangeEventHandler<HTMLInputElement>;
    onEnter: KeyboardEventHandler;
    codeParts: Array<string>;
    length: number;
    id: string;
    disabled?: boolean;
    className?: string;
    numbersOnly?: boolean;
}

export default function CodeInput(props: Props) {
    const {onChange, onEnter, codeParts, id, length, disabled, className, numbersOnly} = props;

    function onKeyDown(index: number) {
        return function (event: React.KeyboardEvent<HTMLInputElement>) {
            if (event.key === 'Backspace' && codeParts[index].length === 0 && index > 0) {
                event.preventDefault();
                document.getElementById(`${id}-${index - 1}`)?.focus();
            } else if (numbersOnly && !event.key.match(/\d/)) event.preventDefault();
            onEnter(event);
        };
    }

    function onFocusInput(evt: React.FocusEvent<HTMLInputElement>) {
        const element = evt.target;
        element.selectionStart = 0;
        element.selectionEnd = element.value.length;
    }

    function renderInput(index: number) {
        return (
            <input
                className='code-input'
                key={index}
                id={`${id}-${index}`}
                value={codeParts[index]}
                onChange={onChange(index)}
                onKeyDown={onKeyDown(index)}
                disabled={disabled}
                autoFocus={index === 0}
                onFocus={onFocusInput}
            />
        );
    }

    const inputs: Array<ReactElement> = [];
    for (let ix = 0; ix < length; ix++) {
        inputs.push(renderInput(ix));
    }
    return <div className={classNames('code-input-container', disabled && 'disabled', className)}>{inputs}</div>;
}
